import { useAsyncData, useRoute } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchPickersInternal(route = useRoute()) {
  const { grade, offerType, variantClicked, productId } = useUrlParams(route)
  const $httpFetch = useHttpFetch()
  const experiments = useExperiments()

  const pickersQueryParams = computed(() => {
    const values = {
      grade: grade.value ? String(grade.value) : null,
      special_offer_type: offerType.value ? String(offerType.value) : null,
      premium_grade: true,
      cheapest_by_grade: !variantClicked,
      apple_watch_band_experiment_enabled:
        experiments['experiment.ppAppleWatchBand'] === 'withoutBand',
    }

    return removeEmptyValuesInObject(values)
  })

  return useAsyncData(
    () =>
      getAsyncDataKey('pp-pickers', {
        productId,
        ...pickersQueryParams.value,
      }),
    async () =>
      await $httpFetch('/product-page/products/:productId/pickers', {
        pathParams: { productId },
        query: pickersQueryParams.value,
      }),
    {
      dedupe: 'defer',
    },
  )
}
